var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app-bar',{staticClass:"kimsa-elevation",staticStyle:{"z-index":"2"},attrs:{"dense":"","fixed":"","light":"","color":"white"}},[_c('v-img',{attrs:{"src":require('@/assets/img/logo_header.png'),"eager":"","max-width":"160","contain":""}})],1),_c('v-sheet',{attrs:{"height":"20","color":"transparent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }